import { createWebHistory, createRouter } from "vue-router";

import login from "@/page-start/views/login-page.vue";
import register from "@/page-start/views/register-page.vue";
//import modspec from "@/page-start/views/modspec-page.vue";
import about from "@/page-start/views/about-page.vue";
import scoping from "@/page-start/views/scoping-page.vue";
import pricing from "@/page-start/views/pricing-page.vue";
import scopingtool from "@/page-start/views/scopingtool-page.vue";
import assessment from "@/page-start/views/assessment-page.vue";
import construction from "@/page-start/views/construction-page.vue";
import resetPassword from "@/page-start/views/reset-password.vue";
import newquote from "@/page-start/views/newquote-page.vue";

const routes = [
  
  {
    path: "/",
    name: "Modspec",
    component: login,//modspec
  },
  {
    path: "/about",
    name: "About",
    component: about,
  },
  {
    path: "/scoping",
    name: "Scoping",
    component: scoping,
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: pricing,
  },
  {
    path: "/scopingtool/:id?",//optional
    name: "ScopingTool",
    component: scopingtool,
  },
  {
    path: "/assessment",
    name: "AssessmentPage",
    component: assessment,
  },
  {
    path: "/construction/:id",
    name: "Construction",
    component: construction,
  },
  {
    path: "/login",
    name: "Login",
    component: login,
  },
  {
    path: "/resetPassword/:id",
    name: "resetPassword",
    component: resetPassword,
  },
  {
    path: "/register",
    name: "Register",
    component: register,
  },
  {
    path: "/newquote/:id?",
    name: "NewQuote",
    component: newquote,
  }
];

  
const router = createRouter({
    history: createWebHistory(),
    base:'/',
    routes,
  });
  
  export default router;
